import type { FC, ReactNode } from 'react';

import { SectionLabel } from './typography';
import styles from './SectionRow.module.css';

interface SectionRowProps {
  label: ReactNode;
  action?: ReactNode;
  labelTestId?: string;
  className?: string;
}

export const SectionRow: FC<SectionRowProps> = ({ label, action, labelTestId, className }) => (
  <div className={className ? `${styles.row} ${className}` : styles.row}>
    <SectionLabel data-testid={labelTestId}>{label}</SectionLabel>
    {action}
  </div>
);
